import axios        from 'axios';
import authHeader   from 'services/auth-header';
import drIds        from 'services/dr-ids';
import drIdsHashed  from 'services/dr-ids-hashed';

class ClaimsService  {
  list(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'eb/dr_new/claims?' + parameters + drIds(), { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  assistantClaims(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'eb/dr_new/claims/assistant_view_claims?' + parameters + drIds(), { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  downloadCsv(parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'eb/dr_new/claims/assistant_view_claims.csv?' + parameters, { headers: authHeader(), responseType: 'blob' })
      .then(response => {
        return response.data;
      }
    );
  }

  show(id) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'eb/dr_new/claims/' + id + '?' + drIds(), { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  associationList(id, parameters) {
    return axios
      .get(process.env.REACT_APP_API_ENDPOINT + 'eb/dr/claims/' + id + '/search/?' + parameters, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  // eyewears(parameters) {
  //   return axios
  //     .get(process.env.REACT_APP_API_ENDPOINT + 'eb/eyewears?' + parameters, { headers: authHeader() })
  //     .then(response => {
  //       return response.data;
  //     }
  //   );
  // }

  submitClaim(id, parameters) {
    const docParam            = drIdsHashed();
    var dataParams            = parameters;
    dataParams.eb_doctor_id   = docParam.doctor_id;
    dataParams.eb_location_id = docParam.location_id;

    return axios
      .put(process.env.REACT_APP_API_ENDPOINT + 'eb/dr/claims/' + id, dataParams, { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }

  deleteClaim(id) {
    return axios
      .delete(process.env.REACT_APP_API_ENDPOINT + 'eb/dr_new/claims/' + id + '?' + drIds(), { headers: authHeader() })
      .then(response => {
        return response.data;
      }
    );
  }
}

export default new ClaimsService();